import request from '@/api/request'
/**
 * 删除材料
 */
export function materialDelApi (query) {
  return request({
    url: '/auth/material/del',
    method: 'delete',
    params: query
  })
}

/**
 * 材料列表
 */
export function materialListApi () {
  return request({
    url: '/auth/material/list',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/my/material.js